export var PermissionTypes;
(function (PermissionTypes) {
    PermissionTypes["SETTINGS"] = "settings";
})(PermissionTypes || (PermissionTypes = {}));
export var PermissionLevel;
(function (PermissionLevel) {
    PermissionLevel["NONE"] = "none";
    PermissionLevel["VIEWER"] = "viewer";
    PermissionLevel["EDITOR"] = "editor";
})(PermissionLevel || (PermissionLevel = {}));
export const permissionConfig = {
    [PermissionTypes.SETTINGS]: {
        title: `Settings`,
        description: `Access to view and edit all settings, including policies & groups.`,
        levels: {
            [PermissionLevel.VIEWER]: {
                description: `Can view all settings but not make changes.`,
            },
            [PermissionLevel.EDITOR]: {
                description: `Can view and edit all settings, including policies & groups.`,
            },
        },
    },
};
//# sourceMappingURL=permissions.js.map